export default {
  contact_information: "Contact information",
  decimal_separator: ".",
  form: {
    email: "E-mail",
    password: "Password",
    password_short: "Key",
    tag_id: "Chip ID",
    tag_id_short: "ID",
    tag_id_long: "Chip ID (First 14 digits)",
    name: "Name",
    surname: "Surname",
    document: "Document",
    phone_number: "Phone",
    birthdate: "Birthdate",
    gender: "Gender",
    country: "Country",
    locator: "Ticket code",
    locator_short: "Code",
  },
  balance: {
    profile: "Profile",
    log_out: "Sign out",
  },
  gender: {
    MALE: "Male",
    FEMALE: "Female",
  },
  actions: {
    sign_up: "Sign up",
    sign_in: "Sign in",
    recover_password: "Recover my password",
    already_have_account: "I've already signed up",
    back_to_login: "Go back to login",
    not_remember_password: "I don't remember my password",
    register_prompt: "Is it your first time here?",
    accept: "Okay!",
    close: "Close",
    change_password: "Change my password",
    set_password: "Add this password",
    request_refund: "Request balance refund",
    recharge: "Top up",
    confirm_request: "Confirm request",
    sign_with_tag: "Sign up with nfc tag id",
    sign_with_ticket: "Sign up with ticket code",
    change_sign_up_method: "Change sign up method",
    sign_up_type: {
      no_reference: "Email",
      tag: "Tag",
      ticket: "Ticket",
    },
    confirm_select: "Next",
    cancel: "Cancel",
    ok: "Ok",
    see_more: "See more",
  },
  headers: {
    sign_up_title: "Sign Up",
    sign_up_type: "Choose how you want to access",
    sign_up: "Fill your data",
    sign_up_success: "Almost ready!",
    sign_up_already: "Do you already have an account?",
    do_not_have_code: "I don´t have a code",
    do_not_have_tag: "I don´t have a tag",
    do_not_have_code_or_tag: "I don´t have a code or tag",
    sign_in: "Sign In",
    hello: "Hello!,"
  },
  sign_up_options: {
    locator: "Locator",
    tag: "Bracelet Code",
    email: "Email",
  },
  change_password: {
    title: "New Password",
    subtitle:
      "Enter a new password and you will be able to access your account again.",
    password: "New Password",
    repeat_password: "Repeat password",
    no_match: "The password must match in both fields",
    email_send: "Password changed!",
    email_send_subtitle: "You can now continue enjoying your cashless chip",
    short_password: "The password must be at least 8 characters long",
  },
  recover: {
    title: "Recover password",
    subtitle:
      "Enter your email and we will send you instructions to recover your password.",
    email: "Email",
    go_back: "Return",
    email_send: "Email sent!",
    email_send_subtitle:
      "If the email entered matches the one you used to register, you will receive instructions to choose a new password.",
  },
  sign_in: {
    email: "Email",
    password: "Password",
    login: "Log in",
    login_with_google: "Log in with Google",
    login_with_apple: "Log in with Apple",
    go_back: "Return",
    forgot_password: "Forgot password?",
    have_account: "Don't have an account?",
    register: "Sign up here",
    email_or_password_cannot_be_null: "Email or password cannot be null",
  },
  sign_up: {
    search: "Search",
    continue_with_google: "Continue with Google",
    continue_with_apple: "Continue with Apple",
    read_terms: "I have read and accept the",
    terms: "terms and conditions",
    go_back: "Return",
    access: "Access",
    confirm_password: "Confirm Password",
    email_send: "E-mail sent!",
    email_send_subtitle:
      "We have sent an email to create your account, check your email or your spam folder",
    locator: {
      name: "Locator",
      title: "1.- Locator",
      title_second_step: "2.- Email Access",
      subtitle: "Enter your ticket code and search.",
      success: "Ticket code confirmed!",
      failed: "Oops! We couldn’t find this ticket code."
    },
    tag: {
      title: "Bracelet code",
      title: "1.- Bracelet code",
      title_second_step: "2.- Email Access",
      subtitle: "Enter the code of your bracelet and search.",
      success: "Code of bracelet confirmed!",
      failed: "Oops! We couldn’t find this code of bracelet."
    },
    no_reference: {
      title: "1.- Email Access",
      subtitle: "Enter your email",
    },
    set_password: {
      title: "Create a password",
      subtitle: "Choose a password and you will have your account to enjoy!",
      password: "Password",
      repeat_password: "Repeat password",
      no_match: "The password must match in both fields",
      email_send: "Account created!",
      email_send_subtitle: "We have sent an email with the usage information, check your email or your spam folderHemos enviado un correo con la información de uso, revisa tu correo o tu carpeta de spam",
      short_password: "The password must be at least 8 characters long",
    },
    placeholder_example: "E.G: 000021504545",
  },
  main: {
    invitations: "Your invitations",
    reached_end: "There are no more transactions",
    no_transactions: "It seems like you don't have any transactions yet.",
    load_more_transactions: "Load more",
    recharge_prompt: "Do you want to top up your chip?",
    transactions_warning:
      "Transactions may not be up to date due to connection issues",
    balance: "My balance",
    token: "Invitations",
    recharge: "Recharge",
    pay: "Pay",
    redeem_bracelet: "Redeem bracelet",
    pre_order: "Pre-order",
    transactions: "Transactions",
    balance_return: "Balance return",
    balance_return_disabled_msg: "It will be activated on {date}",
    user_data: "User data",
    more_options: "See more options",
    back_home: "Back to main menu",
    see_qr: "See QR",
    products: "Products",
    my_token: "My Invitations",
    no_tokens: "You have no tokens",
    no_tokens: "You have no discount coupons",
    available_discount_coupons: "You have {total_discounts} benefits available to redeem!",
    benefits: "Benefits",
    show_expired_coupons: "Show expired coupons",
    check_your_benefits: "Check your benefits!"
  },
  transactions: {
    title: "Transactions",
    last_transactions: "Last transactions",
    all_transactions: "Showing all transactions",
    sync_warning: "Transactions may not be up to date due to connection issues",
    transaction_types: {
      title: "Transaction type",
      ORDER: "Order payment",
      ORDER_REFUND: "Order refund",
      RECHARGE: "Balance top up",
      RECHARGE_REFUND: "Top up refund",
      TOKEN_DECREMENTAL: "Invitation order",
      TOKEN_INCREMENTAL: "Invitation",
      TOKEN: "Tokens top up",
      ONLINE: "Online",
    },
    origin: {
      ORDER: "Payment on ",
      ORDER_REFUND: "Refunded on ",
      RECHARGE: "Topup on ",
      RECHARGE_REFUND: "Refunded on ",
      TOKEN_DECREMENTAL: "Payment with invitation on ",
      TOKEN_INCREMENTAL: "Invitation on ",
    },
    with_reference: {
      mercadopgo: " with Mercado Pago",
      paylands: " with card",
      mit: " with card",
    },
    station: "Station",
    has_refund: {
      total: "This transaction has been fully refunded.",
      partial: "Refunded amount: {whole}{separator}{decimal}{currency}",
    },
    total: "Total",
    total_tokens: "Total tokens",
    got_invitation: "You got an invitation!",
    product: "Product",
    quantity_short: "Qty",
    price: "Price",
    no_transactions: "You have no transactions",
  },
  mercadopago: {
    qr_placement: "You can find your QR on your event card.",
    app_recharge: "or recharge using this app",
    recharge_instructions: `Scan the QR code with the Mercado Pago app and complete the payment process. Your top up will show on your balance shortly after completion.\nYou can download the app from your app store.`,
  },
  payment: {
    recharge_your_wristband: "Top up your chip",
    payment_method: "Payment method",
    upgrade_to: "Upgrade to {category}",
    methods: {
      PAYLANDS: "Card (paylands)",
      MERCADOPAGO: "Mercado Pago",
      MIT: "Card (centro de pagos)",
      PVS: "Card (PVS)"
    },
    topup_with: {
      paylands: "Top up with card (paylands)",
      mercadopago: "Top up with Mercado Pago",
      mit: "Top up with card (centro de pagos)",
      pvs: "Top up with card (PVS)"
    },
    new_card: "Pay with new card",
    your_cards: "Your cards",
    pay_with_card: "Pay with this card",
    card: {
      holder: "Holder",
      expiry: "Expires",
    },
    success: {
      category_updated: "Your category has been updated!",
      current_balance: "The payment was successfully completed",
      button: "Home",
      tip: "It might take some time for the balance to be available on your chip. Please, be patient.",
      tip_category:
        "It might take some time for the category to update on your chip. Please, be patient.",
      title: "Success!",
    },
    error: {
      tip: "Something went wrong during the payment process. Please, retry to finish topping up your chip.",
      button: "Retry",
      title: "Oops!",
    },
    warning: [
      "Keep in mind that the displayed balance may not match the one on your chip correctly (this is due to connection issues).",
      "The balance indicated by your chip will always be the most accurate and correct.",
    ],
  },
  categories: {
    upgrade: "Upgrade",
    no_category: "You don't have a category",
    title: "Upgrade your category",
  },
  tips: {
    recover_password:
      "We'll send you the instructions to recover your password to the mail you used to create your account.",
    tag_id: {
      tag_placement:
        "You can find your chip ID on the front or back of your chip.",
      id_description: "It's a 15 digit long string of numbers and letters.",
    },
    invitations:
      "Invitations can be exchanged for products when you order. Different invitations can be exchanged for different products.",
  },
  balance_refund: {
    title: "Refund",
    current_balance: "My current balance",
    processing_time_tip:
      "The refund might take up to 24hrs to complete. Thank you for your patience.",
    tip: "By requesting a balance refund, you’ll get back the remaining balance on your chip and your chip will stop working. Only the balance topped up with the app is refundable.",
    refundable_balance: "Your app refundable balance is:",
    facility_refundable_balance: "Refund your remaining balance on {location}:",
    location: {
      hotel: "reception",
      festival: "the event",
    },
    requested: "Requested",
    status: "Status",
    updated: "Updated",
    pending_refund: "Pending refund",
    status_types: {
      PENDING: "Requested",
      NOT_REFUNDABLE: "Not refundable",
      COMPLETED: "Issued",
      PARTIALLY_COMPLETED: "Issued",
      NOTHING_TO_REFUND: "Nothing to refund",
    },
    available_date: "Your refund will be available from ",
    warnign_balance:
      "This application does not return recharges made at the window",
    warnign_refundable_balance:
      "You can only return the balance recharged through this application or virtually.",
    confirm_action: "Request balance return",
    success_refund: {
      primary_text: "Refund requested!",
      secondary_text:
        "Your return is being processed, you will receive your money in 2-3 days",
    },
    refund_pending: "Processing refund",
  },
  modals: {
    sign_up: {
      title: "Signed up!",
      content:
        "Check your email, we have sent an email to <b> {email} </b> to complete your registration",
      legal: "Terms and conditions",
      legal_notice: "By signing up, you accept our ",
      locator:
        "Enter the ticket code next to the QR/barcode. If it does not appear on your ticket, scan the QR/barcode to get it.",
    },
    recover: {
      title: "E-mail sent!",
      content:
        "If the mail you provided was used to create an account, you'll receive the instructions to reset your password.",
    },
    qr: {
      title: "Your QR code",
      footer: "This is your personal identifier code",
    },
  },
  success: {
    edit_profile: "Correctly applied changes",
  },
  error: {
    server_error: "Something broke on the server. We're working on it!",
    server_unavailable:
      "Oops! It seems like the server is unavailable. Come back later!",
    bad_request: {
      any: {
        required: "Required",
        empty: "Required",
      },
      string: {
        base: "Required",
        email: "Invalid e-mail",
        hex: "Invalid code. It should have 14 or 15 digits.",
        invalid_tag: "Invalid code. Check your digits.",
        min: "Doesn't reach min length",
      },
    },
    conflict: {
      EMAIL_IN_USE: "An account with this e-mail already exists.",
      EMAIL_OR_TOKEN_IN_USE: "An account with this e-mail already exists.",
      LINK_IN_USE: "An account has already been created with this chip ID.",
      NOTHING_TO_REFUND: "Nothing to refund.",
      INVALID_TOKEN: "Your link has expired. Please restart the process.",
      NO_TOOLKIT_USER_FOUND: "Oops! We couldn't find that user.",
      INVALID_EXTERNAL_TOKEN: "Invalid authentication token"
    },
    forbidden: "Wrong email or password",
    invalid_token: "Invalid authentication token",
    agree_terms: "You must agree terms to continue",
    user_not_balance: "You have no balance to refund",
    user_not_tag: "Not available. You do not have a tag id"
  },
  qr_view: {
    qr_text: "Showing your QR code",
    dismiss_text: "Go back",
  },
  my_account: {
    title: "My account",
    user_data: "User info",
    change_password: "Change password",
    legal_terms: "Legal terms",
    show_qr_code: "Show QR code",
    logout: "Logout",
    confirm_logout: "Do you want to close your session?",
    password_changed: "Password changed!",
  },
  recharge: {
    title: "Recharge",
    current_balance: "Current balance",
    new_balance: "New balance",
    recharge_amount: "Amount to recharge",
    card_payment: "Card paymemt",
    recharge_done: "Recharge done!",
    no_payment_config: "No payment method configured",
  },
  user: {
    title: "User data",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    ok: "Ok",
    success_response: {
      primary_text: "Data saved!",
    },
    save_changes: "Save changes",
  },
  redeem_tag_dialog: {
    text: "Show your QR code at a station to redeem your tag and enjoy the event."
  },
  discount_coupon: {
    expiration: "Expiration",
    uses: "Uses",
    applicable_products: "Applicable produts",
    price: "Price",
  }
};
